import { Mail, MapPin, MessageCircle } from "lucide-react";
import { CONTATO } from "../data/chales";

export default function Footer() {
  return (
    <footer
      id="contato"
      className="bg-[#1C3026] px-6 py-20 text-[#F6F5F2] md:px-12 lg:px-24"
      data-testid="footer"
    >
      <div className="grid gap-12 md:grid-cols-3">
        <div>
          <div className="flex items-center gap-3">
            <img
              src="/logo.jpg"
              alt="Laguna Alto Viçosa"
              className="h-12 w-12 rounded-full bg-white object-cover"
            />
            <span className="text-sm font-bold uppercase tracking-[0.25em]">Laguna Alto Viçosa</span>
          </div>
          <p className="mt-6 max-w-xs text-sm leading-relaxed text-[#F6F5F2]/70">
            Chalés de luxo nas montanhas do Espírito Santo. Aconchego, natureza e momentos
            inesquecíveis.
          </p>
        </div>
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-[#d8c9b0]">Contato</p>
          <ul className="mt-6 space-y-4 text-sm">
            <li>
              <a
                href={`https://wa.me/${CONTATO.whatsapp}`}
                target="_blank"
                rel="noreferrer"
                className="flex items-center gap-3 transition-colors hover:text-[#d8c9b0]"
                data-testid="footer-whatsapp"
              >
                <MessageCircle className="h-4 w-4 shrink-0" /> {CONTATO.whatsappDisplay}
              </a>
            </li>
            <li>
              <a
                href={`mailto:${CONTATO.email}`}
                className="flex items-center gap-3 transition-colors hover:text-[#d8c9b0]"
                data-testid="footer-email"
              >
                <Mail className="h-4 w-4 shrink-0" /> {CONTATO.email}
              </a>
            </li>
            <li className="flex items-start gap-3 text-[#F6F5F2]/70">
              <MapPin className="mt-0.5 h-4 w-4 shrink-0" /> {CONTATO.endereco}
            </li>
          </ul>
        </div>
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-[#d8c9b0]">Informações</p>
          <ul className="mt-6 space-y-3 text-sm text-[#F6F5F2]/70">
            <li>CNPJ: {CONTATO.cnpj}</li>
            <li>Reservas pelo site ou WhatsApp</li>
            <li>Pagamento: Pix ou cartão em até 6x sem juros</li>
            <li>Pet friendly — consulte condições</li>
          </ul>
        </div>
      </div>
      <div className="mt-16 border-t border-[#F6F5F2]/10 pt-8 text-xs text-[#F6F5F2]/50">
        © 2026 Laguna Alto Viçosa — Todos os direitos reservados.
      </div>
    </footer>
  );
}
